import Card, { CardProps } from '@mui/material/Card';
import { alpha, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

const PREFIX = 'InfoCard';

const classes = {
  title: `${PREFIX}-title`
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`& .${classes.title}`]: {
    color: alpha(theme.palette.text.primary, 0.9)
  }
}));

interface InfoCardProps extends React.PropsWithChildren<CardProps> {
  title: string;
  value: string;
  subtitle: string;
  subvalue: string;
  'data-testid'?: string;
  className?: string;
}

const InfoCard = ({ title, value, subtitle, subvalue, children, ...cardProps }: InfoCardProps) => {
  return (
    <StyledCard {...cardProps}>
      <Typography className={classes.title} variant="subtitle1" data-testid="info-card-title">
        {title}
      </Typography>
      <Typography noWrap variant="body2" data-testid="info-card-value">
        {value}
      </Typography>
      <Typography className={classes.title} variant="subtitle1" data-testid="info-card-subtitle">
        {subtitle}
      </Typography>
      <Typography variant="body2" data-testid="info-card-subvalue">
        {subvalue}
      </Typography>
      {children}
    </StyledCard>
  );
};

export default InfoCard;
